import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { getCompatibilityMapping } from '../store/actions/compatibility'
import CompatibilityComponent from '../components/developerApi/developerSdk/Compatibility/CompatibilityComponent';

const mapStateToProps = ({ compatibility: { isLoading, apis, commonApis, consoleSpecificApis } }) => ({
    isLoading,
    apis,
    commonApis,
    consoleSpecificApis,
})

const mapDispatchToProps = {
    getCompatibilityMapping,
}

// const mergeProps = (
//     { apis, commonApis, consoleSpecificApis, ...stateProps },
//     { getCompatibilityMapping },
// ) => {
//     return {
//         ...stateProps,
//         getCompatibilityMapping: () => getCompatibilityMapping(),
//     }
// }

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CompatibilityComponent));



// WEBPACK FOOTER //
// ./src/containers/CompatibilityContainer.js